import Vue from 'vue'
import Vuex from 'vuex'
import rw1 from '../assets/image/tu3.png'
import rw2 from '../assets/image/tu7.png'
import rw3 from '../assets/image/tu8.png'
import rw4 from '../assets/image/tu9.png'

import yx1 from '../assets/image/yx1.png'
import yx2 from '../assets/image/yx2.png'
import yx3 from '../assets/image/yx3.png'
import yx4 from '../assets/image/yx4.png'

import cyx1 from '../assets/image/cyx1.png'
import cyx2 from '../assets/image/cyx2.png'
import cyx3 from '../assets/image/cyx3.png'
import cyx4 from '../assets/image/cyx4.png'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
     load_show:false,
     menuList:[    
      {id:1,title:'Home',path:'index'},
      {id:3,title:'Games',path:'games'},
      {id:2,title:'About us',path:'aboutus'},
      // {id:8,title:'Join us',path:'join',},
      // {id:4,title:'pages',path:'',child:[{id:5,title:'Privacy Policy',path:'privacypolicy',},{id:6,title:'Terms Of Use',path:'terms',}]},
      {id:5,title:'Privacy Policy',path:'privacypolicy',},
      {id:6,title:'Terms Of Use',path:'terms',},
      // {id:7,title:'Contact Us',path:'contactus',},
    
      
     
      ],
      joinList:[
        {id:1,img:rw1,title:'The Spark',show:false,year:'2021',
          msg1:"FUTURE LASER was born in 2021, driven by a dream to craft immersive and memorable gaming experiences that resonate with players.",
          msg2:"Examine in-game visuals, icons, and text for compliance and quality.</br> Verify adherence to national and regional laws.</br> Collaborate with teams to maintain content integrity.</br> What We’re Looking For:</br> Passion for gaming, especially casual titles. </br>Detail-oriented with a commitment to excellence.</br> Experience in content review and strong teamwork skills.",
          msg3:"• Requires 2+ years of game design experience, proficiency in design tools (e.g., Unity, Adobe Suite), and a passion for player-centric design.",
          msg4:"• Location: Remote or Copenhagen, Denmark. Apply by emailing your portfolio to support@futurelastertech.com."
        },
        {id:2,img:rw2,title:'Global Breakthrough',show:false,year:'2022',
          msg1:"In 2022, we launched our first major title, introducing innovative gameplay and storytelling to a global audience.",
          msg2:"Handle document management, meeting scheduling, and office supplies. </br> Support leadership with calendar coordination.</br> Welcome visitors and uphold our company’s professional image.</br> Facilitate cross-departmental communication.</br> What We’re Looking For: </br>Strong organizational and multitasking skills.</br> Proficiency in Microsoft Office or similar tools.</br> High sense of responsibility and discretion. </br>Excellent interpersonal skills to build strong relationships.",
          msg3:"• Requires a degree in Computer Science or equivalent experience, 3+ years in software development, and expertise in C++ or JavaScript. Location: Remote or Copenhagen, Denmark.",
          msg4:"• Send your resume to support@futurelastertech.com."
         
        },
        {id:3,img:rw3,title:'Building Momentum',show:false,year:'2024',
          msg1:"By 2024, our commitment to quality and creativity grew our community, setting new benchmarks in interactive entertainment.",
          msg2:"Oversee project planning, set goals, and allocate resources efficiently. </br> Collaborate with teams to resolve challenges and ensure smooth progress. </br> Provide progress reports and data-driven insights to leadership. </br> What We’re Looking For: </br> Proven experience in project management, ideally in gaming or tech. </br> Strong strategic thinking and problem-solving skills. </br> Excellent leadership and communication abilities. </br> Familiarity with project management methodologies like Agile.",
          msg3:"• Requires excellent communication skills, 1+ years in community management, and familiarity with gaming trends.",
          msg4:"• Location: Remote or Copenhagen, Denmark. Apply with your cover letter to support@futurelastertech.com."
        },
        {id:4,img:rw4,title:'Pioneering the Future',show:false,year:'2025',
          msg1:"In 2025,FUTURE LASER continues to innovate, merging technology and artistry to create the next wave of gaming adventures.",
          msg2:"Oversee project planning, set goals, and allocate resources efficiently. </br> Collaborate with teams to resolve challenges and ensure smooth progress. </br> Provide progress reports and data-driven insights to leadership. </br> What We’re Looking For: </br> Proven experience in project management, ideally in gaming or tech. </br> Strong strategic thinking and problem-solving skills. </br> Excellent leadership and communication abilities. </br> Familiarity with project management methodologies like Agile.",
          msg3:"• Requires excellent communication skills, 1+ years in community management, and familiarity with gaming trends.",
          msg4:"• Location: Remote or Copenhagen, Denmark. Apply with your cover letter to support@futurelastertech.com."
        },
      ],
      games:[
        {id:1,title:'Galaxy Chaos Survivors',icon:yx1,img:cyx1,
          info:'',
          msg:'An action-packed adventure game where players navigate through cosmic chaos, battling enemies and collecting power-ups to survive increasingly challenging waves of galactic threats. With stunning visuals and immersive gameplay, Galaxy Chaos Survivors offers endless hours of entertainment.',
          url:'https://www.betatechgame.com/game5/',status:'1',
        },
        {id:2,title:'Neon Drift',icon:yx2,img:cyx2,
          info:"",
          msg:"Race through Nexus City in Neon Drift, a fast-paced cyberpunk racer. Customize hovercars, dodge drones, and compete in shifting tracks. Align with corporations or rebels to unlock challenges in a neon-soaked world.",
          url:'',status:'0',
        },
        {id:3,title:'Starforge Chronicles',icon:yx3,img:cyx3,
          info:'',
          msg:'Lead a space colony in Starforge Chronicles, a strategy game in a vast galaxy. Explore planets, build starships, and negotiate with aliens. Your choices shape your empire through resource management and cosmic conflicts.',
          url:'',status:'0',
        },
        {id:4,title:'Whispers of the Forgotten',icon:yx4,img:cyx4,
          info:'',
          msg:'Investigate Hollowridge’s dark secrets in Whispers of the Forgotten, a horror game. Solve puzzles, evade entities, and uncover a chilling narrative in eerie settings. Your choices decide if you break the town’s curse.',
          url:'',status:'0',
        },
      ],
    },
  
    mutations: {
      setLoad (state, value) {
        state.load_show = value
      }, 
    },
   
})
